import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { userApi } from '../../api/user.api';
import { useUI } from '../../store/UIContext';
import { PageHeader, Btn, Spinner } from '../../components/ui/index';
import { composeCompanyUsername, DEFAULT_USERNAME_SPLITTER } from '../../utils/usernamePrefix';

const PRESETS = ['_', '.', '-', '@'];

export default function UsernamePrefixSettingsPage() {
  const { addToast } = useUI();
  const [splitter, setSplitter] = useState(DEFAULT_USERNAME_SPLITTER);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    userApi.getUsernamePrefixSettings()
      .then((res) => setSplitter(res.data?.splitter || DEFAULT_USERNAME_SPLITTER))
      .catch(() => addToast('خطا در دریافت تنظیمات', 'error'))
      .finally(() => setLoading(false));
  }, [addToast]);

  const save = async () => {
    const value = splitter.trim();
    if (!value) { addToast('جداکننده نمی‌تواند خالی باشد', 'error'); return; }
    if (/\s/.test(value)) { addToast('جداکننده نباید فاصله داشته باشد', 'error'); return; }
    setSaving(true);
    try {
      const res = await userApi.saveUsernamePrefixSettings({ splitter: value });
      setSplitter(res.data?.splitter || value);
      addToast('جداکننده ذخیره شد', 'success');
    } catch (e) {
      addToast(e.response?.data || 'خطا در ذخیره', 'error');
    }
    setSaving(false);
  };

  const preview = composeCompanyUsername('نام‌شرکت', 'کاربر', splitter || DEFAULT_USERNAME_SPLITTER);
  const inp = { width: '100%', maxWidth: 220, padding: '10px 14px', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 16, outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box', textAlign: 'center', letterSpacing: 2 };

  return (
    <div className="fade-in">
      <PageHeader
        title="جداکننده نام کاربری"
        subtitle="نام شرکت با این کاراکتر قبل از نام کاربری ذخیره می‌شود"
        action={<Link to="/settings" style={{ fontSize: 13, color: '#64748b' }}>بازگشت به تنظیمات</Link>}
      />
      {loading ? <Spinner /> : (
        <div style={{ maxWidth: 520, background: '#fff', borderRadius: 16, border: '1px solid rgba(35,58,122,0.1)', padding: 32 }}>
          <label htmlFor="username-splitter" style={{ fontSize: 12, fontWeight: 600, color: '#334155', display: 'block', marginBottom: 5 }}>جداکننده بین نام شرکت و نام کاربری</label>
          <input id="username-splitter" value={splitter} onChange={(e) => setSplitter(e.target.value)} maxLength={8} dir="ltr" style={inp} />
          <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
            {PRESETS.map((p) => (
              <button key={p} type="button" onClick={() => setSplitter(p)} style={{ padding: '6px 12px', borderRadius: 8, border: `1.5px solid ${splitter === p ? '#29AAE1' : '#e2e8f0'}`, background: splitter === p ? '#EDF3FC' : '#fff', color: '#233A7A', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>{p}</button>
            ))}
          </div>
          <p style={{ fontSize: 12, color: '#64748b', margin: '16px 0 0' }}>نمونه نام کاربری نهایی:</p>
          <p dir="ltr" style={{ fontSize: 14, fontWeight: 700, color: '#0f172a', margin: '6px 0 0', wordBreak: 'break-all' }}>{preview}</p>
          <div style={{ marginTop: 20 }}>
            <Btn onClick={save} loading={saving}>ذخیره</Btn>
          </div>
        </div>
      )}
    </div>
  );
}
